import { z } from 'zod';
import dayjs, { Dayjs } from 'dayjs';
import { DurationType } from '../../../1_shared/config/interfaces/DurationType';

const MINIMUM_DAYS = 1;

export const scheduleWeekSchema = z
  .object({
    dates: z.array(z.string()).min(MINIMUM_DAYS),
    dayStartAt: z.instanceof(dayjs as unknown as typeof Dayjs),
    dayEndAt: z.instanceof(dayjs as unknown as typeof Dayjs),
    breakStartAt: z.instanceof(dayjs as unknown as typeof Dayjs).nullable(),
    breakEndAt: z.instanceof(dayjs as unknown as typeof Dayjs).nullable(),
    duration: z.nativeEnum(DurationType).nullable(),
  })
  .superRefine(
    ({ breakStartAt, breakEndAt, dayStartAt, dayEndAt, duration }, ctx) => {
      if (!breakStartAt && breakEndAt) {
        ctx.addIssue({
          code: 'custom',
          message: 'Введите начало перерыва',
          path: ['breakStartAt'],
        });
      }
      if (breakStartAt && !breakEndAt) {
        ctx.addIssue({
          code: 'custom',
          message: 'Введите конец перерыва',
          path: ['breakEndAt'],
        });
      }
      if (!dayEndAt) {
        ctx.addIssue({
          code: 'custom',
          message: 'Введите начало время работы',
          path: ['dayEndAt'],
        });
      }
      if (!dayStartAt) {
        ctx.addIssue({
          code: 'custom',
          message: 'Введите конец время работы',
          path: ['dayStartAt'],
        });
      }
      if (!duration) {
        ctx.addIssue({
          code: 'custom',
          message: 'Укажите продолжительность сессии',
          path: ['duration'],
        });
      }
    },
  );

export type TScheduleWeek = z.infer<typeof scheduleWeekSchema>;
